import React from 'react';
import { NavBar } from '../components/NavBar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { SkillsSection } from '../components/SkillsSection';
import { ProjectsSection } from '../components/ProjectsSection';
import { ClientsSection } from '../components/ClientsSection';
import { ContactSection } from '../components/ContactSection';
export function HomePage() {
  return <div className="min-h-screen bg-[#050510] text-white selection:bg-[#00f5a0] selection:text-black" data-id="element-290">
      <NavBar data-id="element-291" />
      <main data-id="element-292">
        <HeroSection data-id="element-293" />
        <AboutSection data-id="element-294" />
        <ServicesSection data-id="element-295" />
        <SkillsSection data-id="element-296" />
        <ProjectsSection data-id="element-297" />
        <ClientsSection data-id="element-298" />
        <ContactSection data-id="element-299" />
      </main>
    </div>;
}